export default "__VITE_ASSET__DiRZHsjX__"